import { Button, Image } from 'semantic-ui-react';
import moment from 'moment';
import { boolSiNo, profileImage } from '../../helpers';
import { agGridDateCreatedAtFieldComparator } from '../../table/helpers';
import NewVolunteerModal from '../../../containers/volunteer/VolunteerNewAdminModal';

export const NewVolunteersRowDef = ({
  getInfo,
  set_showVolunteer,
  showVolunteer,
  showSecondInterview,
}) => [
  {
    headerName: 'Fecha llenado',
    field: 'createdAt',
    valueGetter: (val) => moment.tz(val.data?.createdAt, 'America/Bogota').format('DD-MM-YYYY'),
    comparator: agGridDateCreatedAtFieldComparator,
    width: 100,
  },
  {
    headerName: 'Datos personales',
    children: [
      {
        headerName: 'Foto',
        field: 'picture',
        cellRenderer: (val) => <Image src={profileImage(val.data)} rounded size="small" />,
        width: 100,
      },
      {
        headerName: 'Nombre',
        field: 'name',
        valueGetter: (val) => `${val.data?.name} ${val.data?.lastName}`,
        width: 180,
      },
      {
        headerName: 'Teléfono',
        field: 'phone',
        columnGroupShow: 'open',
        width: 100,
      },
      {
        headerName: 'Ocupacion',
        field: 'ocupation',
        columnGroupShow: 'open',
        width: 100,
      },
    ],
  },
  {
    headerName: 'Info voluntario',
    children: [
      {
        headerName: 'Confirmado',
        field: 'contacted',
        valueGetter: (val) => boolSiNo(val.data?.contacted),
        width: 100,
      },
      {
        headerName: 'Entrenamiento',
        field: 'training',
        valueGetter: (val) => boolSiNo(val.data?.training),
        width: 100,
      },
      ...(showSecondInterview
        ? [
            {
              headerName: '2da entrevista',
              field: 'secondInterview',
              valueGetter: (val) => boolSiNo(val.data?.secondInterview),
              width: 120,
            },
          ]
        : []),
      {
        headerName: 'Aprobacion Lider',
        field: 'leadercheck',
        width: 150,
      },
      {
        headerName: 'Ingresado como voluntario',
        field: 'promotedVolunteer',
        valueGetter: (val) => boolSiNo(val?.data?.promotedVolunteer),
        width: 100,
      },
    ],
  },
  {
    headerName: 'Ver',
    field: 'seemore',
    sortable: false,
    filter: false,
    cellRenderer: (val) => (
      <>
        {showVolunteer === val?.data?.id && (
          <NewVolunteerModal
            NewVolunteer={val?.data}
            set_showVolunteer={set_showVolunteer}
            getInfo={getInfo}
          />
        )}
        <Button primary onClick={() => set_showVolunteer(val?.data?.id)}>
          Ver
        </Button>
      </>
    ),
    width: 150,
  },
];
